import type { LinkProps } from "react-router-dom";
import { Link } from "react-router-dom";

import type { ButtonProps } from "@/components/ui/button";
import { Button, buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface HeaderActionButtonProps extends ButtonProps {
  label: string;
  goTo?: string;
  variant?: ButtonProps["variant"];
  className?: string;
}

interface HeaderActionProps {
  title: string;
  actions?: Array<HeaderActionButtonProps> | React.ReactNode;
}

type MaybeLinkButtonProps =
  | (LinkProps & {
      variant?: ButtonProps["variant"];
      size?: ButtonProps["size"];
    })
  | ButtonProps;

const MaybeLinkButton = ({ className, ...props }: MaybeLinkButtonProps) => {
  if ("to" in props && props.to) {
    return (
      <Link
        className={cn(
          buttonVariants({ variant: props.variant, size: props.size }),
          className
        )}
        {...props}
      />
    );
  }

  return (
    <Button className={className} {...(props as ButtonProps)} type={"button"} />
  );
};

const HeaderAction = ({ title, actions }: HeaderActionProps) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center gap-4">
      <h3 className="text-lg md:text-2xl">{title}</h3>

      <div className="flex flex-col lg:items-center lg:flex-row gap-4">
        {actions && (
          <div className="flex flex-col gap-[4px] xl:flex-row">
            {Array.isArray(actions)
              ? actions.map(({ label, className, goTo, ...action }) => (
                  <MaybeLinkButton
                    to={goTo ?? ""}
                    key={`header_action_${label.toLowerCase().split(" ").join("_")}`}
                    className={cn("font-semibold", className)}
                    {...action}
                  >
                    {label}
                  </MaybeLinkButton>
                ))
              : actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderAction;
